<template lang="html">
  <div class="editor">
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor" class="text">
    </div>
  </div>
</template>

<script>
import E from 'wangeditor'
import { upload } from '../api/regulation'
export default {
  name: 'Editorbar',
  data () {
    return {
      // domainUrl:domain.testUrl,
      editor: null,
      info_: null
    }
  },
  model: {
    event: 'change'
  },
  props: {
    initVal: {
      type: String,
      default: ''
    },
    isClear: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isClear (val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear()
        this.info_ = null
      }
    },
    initVal (val) {
      this.editor.txt.html(val)
    }
  },
  mounted () {
    this.seteditor(this.initVal)
  },
  methods: {
    seteditor (vale) {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor)
      // this.editor.customConfig.uploadImgShowBase64 = false // base 64 存储图片
      // this.editor.customConfig.uploadImgServer = this.domainUrl+'app/openx/file/TextUpload'// 配置服务器端地址
      // this.editor.customConfig.uploadImgServer = 'http://guard-test.ybveg.com/api/guard/common/file/upload/url'// 配置服务器端地址
      // this.editor.customConfig.uploadImgHeaders = { 'Accept': 'text/x-json' }// 自定义 header
      // this.editor.customConfig.uploadFileName = 'bsLic' // 后端接受上传文件的参数名
      // this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
      // this.editor.customConfig.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
      this.editor.customConfig.showLinkImg = false // 隐藏网络图片上传Tab
      this.editor.customConfig.zIndex = 900
      // this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间
      this.editor.customConfig.customAlert = function (info) {
        // 上传图片错误的提示默认alert, 可自定义
        this.$message.error(info)
      }
      this.editor.customConfig.customUploadImg = async (files, insert) => { // 自定义图片上传
        /* files 是 input 中选中的文件列表 */ 
        /* upload方法是后台提供的上传图片的接口 */
        /* insert 是编辑器自带的 获取图片 url 后，插入到编辑器的方法 上传代码返回结果之后，将图片插入到编辑器中*/ 
        let formData = new FormData() 
        formData.append('file', files[0]) 
        upload(formData).then(res => {
          if(res.code === 200) {
            insert(res.data.fileUrl)
          }
        })
      }
      // 配置菜单
      this.editor.customConfig.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        'code', // 插入代码
        // 'undo', // 撤销
        // 'redo' // 重复
      ]
      // this.editor.customConfig.uploadImgHooks = {
      //   before: function (xhr, editor, files) {
      //     // 图片上传之前触发
      //     // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
      //     // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
      //     // return {
      //     //     prevent: true,
      //     //     msg: '放弃上传'
      //       // }
      //   },
      //   fail: (xhr, editor, result) => {
      //     // 插入图片失败回调
      //   },
      //   success: (xhr, editor, result) => {
      //     // 图片上传成功回调
      //   },
      //   timeout: (xhr, editor) => {
      //     // 网络超时的回调
      //   },
      //   error: (xhr, editor) => {
      //     // 图片上传错误的回调
      //   },
      //   customInsert: (insertImg, result, editor) => {
      //     // 图片上传成功，插入图片的回调
      //       var url = result.url
      //       insertImg(url)
      //   }
      // }
      this.editor.customConfig.onchange = (html) => {
        this.info_ = html // 绑定当前逐渐地值
        this.$emit('change', this.info_) // 将内容同步到父组件中
      }
      // 创建富文本编辑器
      this.editor.create()
      this.editor.txt.html(vale)
    }
  }
}
</script>

<style scoped>

.editor {
  width: 986px !important;
  margin: 0 10px;
  padding: 10px 0 20px 0;
  background: #fff;
  border-radius: 5px;
}
.toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
  height: 400px;
  z-index:888!important;
}
</style>